import {CommentEditor, commenteditor} from "./CommentEditor.js";
import {
	avatar,
	browser,
	btn,
	checkbox,
	checkboxselectcolumn,
	column,
	comp,
	Component,
	DataSourceStore,
	Filter,
	form,
	Form,
	h3,
	h4,
	menu,
	mstbar,
	Notifier,
	paginator,
	router,
	searchbtn,
	t,
	Table,
	tbar
} from "@intermesh/goui";
import {client, img, jmapds, MainThreeColumnPanel} from "@intermesh/groupoffice-core";
import {TaskTable} from "./TaskTable.js";
import {TasklistTable, tasklisttable} from "./TasklistTable.js";
import {CommentList} from "./CommentList.js";


export class MainPanel extends MainThreeColumnPanel {
	private taskTable!: TaskTable;
	private taskListTable!: TasklistTable;
	private commentsList!: CommentList;
	private commentEditor!: CommentEditor;
	private commentForm!: Form;
	private titleCmp!: Component;
	constructor() {
		super("supportclient");
		this.on("render", async () => {
			await this.taskListTable.store.load();
			await this.taskTable.store.load();
		});
	}

	protected createCenter() {
		this.taskTable = new TaskTable();
		this.taskTable.stateId = "supportclient-task-table";

		this.taskTable.on("navigate", ( {storeIndex, record}) => {
			void router.goto("supportclient/" + record.id);
		});

		return comp({
				cls: 'active vbox',
				itemId: 'table-container',
				minWidth: 640,
				width: 900
			},

			tbar({cls: "table-aligned"},
				this.showWestButton(),
				this.openWestButton(),
				checkbox({
					type: "switch",
					label: t("Show completed"),
					listeners: {
						change: async ( {newValue}) => {

							this.taskTable.store.setFilter("status", !newValue ? {complete: false} : undefined);
							await this.taskTable.store.load();
						}
					}
				}),

				'->',

				searchbtn({
					listeners: {
						input: ( {text}) => {

							(this.taskTable.store.queryParams.filter as Filter).text = text;
							this.taskTable.store.load();

						}
					}
				}),

				mstbar({table: this.taskTable}),

				btn({
					itemId: "add",
					icon: "add",
					text: t("New request"),
					cls: "filled primary",
					handler: async () => {

						this.mask();

						// Dynamic import to delay loading of required modules
						const mods = await import("./SupportCreateWindow.js");
						const win = new mods.SupportCreateWindow;

						// const queryCallId =  JmapDataSource.store("Module").nextCallId;
						const queryResponse = await jmapds("Module").query({
							filter: {
								name: "supportclient",
								package: "business"
							}
						});

						//  TODO
						// const modules = await JmapDataSource.store("Module").get({
						// 	resultOf: queryCallId,
						// 	name: "Module/query",
						// 	path: "ids"
						// });

						const modules = await jmapds("Module").get(queryResponse.ids);

						const form = win.findChildByType(Form)!;

						form.value = {
							tasklistId: modules.list[0].settings.defaultTaskListId
						};

						this.unmask();

						win.show();
					}
				}),

				btn({
					icon: "more_vert",
					menu: menu({}, this.taskTable.getVisibleColumnButton())
				})

			),

			comp({
					flex: 1,
					stateId: "support",
					cls: "scroll border-top main"
				},
				this.taskTable
			),


			paginator({
				store: this.taskTable.store
			})
		)
	}


	protected createWest() {


		return comp({
				cls: "vbox scroll",
				width: 300,
				hidden: true
			},
			tbar({

				},
				h4(t("Help")),
				'->',
				this.hideWestButton(),
				this.closeWestButton()
			),

			this.taskListTable = tasklisttable({
				cls: "no-row-lines",
				headers: false,
				rowSelectionConfig: {
					multiSelect: true,
					listeners: {
						selectionchange: ({selected}) => {
							const taskListIds = selected.map((row) => row.record.id);
							this.taskTable.store.setFilter("taskListId", {taskListId: taskListIds.length ? taskListIds : "any"});
							void this.taskTable.store.load();
						}
					}
				},
				columns: [
					checkboxselectcolumn(),
					column({
						id: "name",
						header: t("Name"),
						sortable: true,
						resizable: false
					})
				]
			})
		);
	}

	protected createEast() {

		this.commentEditor = commenteditor({
			flex: 1
		});

		const cmp =  comp({
				itemId: 'scroll-component',
				tabIndex: -1,
				// flex: 1,
				cls: 'scroll bg-lowest'
			},
			tbar({},
				this.hideEastButton(),
				this.titleCmp = h3(),

			),

			this.commentsList = new CommentList(),



			this.commentForm = form({
					hidden: true,
					handler: (form) => {
						jmapds("Comment").create(
							Object.assign({
									entity: "SupportTicket",
									entityId: (this.commentsList.store.queryParams.filter as Filter).entityId,
								}, form.value
							)
						).then(() => {
							form.reset();
						});
					}
				},

				comp({
						cls: "hbox pad"
					},
					comp({
						itemId: "avatar-container"
					}),

					this.commentEditor
				),


				tbar({},
					btn({
						type: "button",
						text: t("Attach files"),
						icon: "attach_file",
						handler: async () => {

							const files = await browser.pickLocalFiles(true);
							this.mask();
							const blobs = await client.uploadMultiple(files);
							this.unmask();


							const atts = this.commentEditor.attachments.value;
							for (let blob of blobs) {
								atts.push({
									name: blob.name,
									blobId: blob.id
								});
							}
							this.commentEditor.attachments.value = atts;

						}
					}),

					'->',

					btn({
						type: "submit",
						text: t("Send"),
						icon: "send"
					})
				)
			)
		)

		this.commentsList.on("listready", () => {
			this.commentForm.el.scrollIntoView({
				behavior: "smooth",
				block: "end"
			})

			this.commentEditor.htmlEditor.focus();
		});

		return cmp;

	}

	async setTaskId(taskId?: string) {

		const table = this.findChildByType(Table<DataSourceStore>)!,
			form = this.findChildByType(Form)!,
			avatarContainer = this.findChild("avatar-container")!;

		try {

			if(!avatarContainer.items.count()) {
				avatarContainer.items.add(client.user.avatarId ?
					img({
						cls: "goui-avatar",
						blobId: client.user.avatarId,
						title: client.user.displayName
					}) :
					avatar({
						displayName: client.user.displayName!
					})
				);
			}


			if (taskId) {

				jmapds("SupportTicket").single(taskId).then((task) => {
					this.titleCmp.text = `${task!.id} - ${task!.title}`;
				});

				(this.commentsList.store.queryParams.filter as Filter).entityId = taskId;
				await this.commentsList.store.load();

				const record = table.store.find((r, index, records) => r.id == taskId);
				if (record) {
					table.rowSelection!.replace(record);
				}

				form.reset();
				form.show();

				this.activatePanel(this.east);

			} else {
				this.commentsList.items.clear();
				form.hide();

				this.activatePanel(this.center);
			}
		} catch (e) {
			Notifier.error(e as Error);
		}
	}
}
